import { Skeleton } from "@/shared/ui";

export default function AddressesFormSkeleton() {
  return (
    <div className="flex flex-col justify-between min-h-[520px] gap-7">
      <div className="flex flex-col gap-7">
        <Skeleton height={28} width={220} />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[0, 1].map((idx) => (
            <div key={idx} className="flex flex-col gap-4">
              <Skeleton height={18} width={220} />

              <div className="flex flex-col gap-1">
                <Skeleton height={16} width={120} />
                <Skeleton height={44} />
              </div>

              <div className="flex flex-col gap-1">
                <Skeleton height={16} width={120} />
                <Skeleton height={44} />
              </div>

              <div className="flex flex-col gap-1">
                <Skeleton height={16} width={120} />
                <Skeleton height={44} />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col gap-1">
                  <Skeleton height={16} width={120} />
                  <Skeleton height={44} />
                </div>
                <div className="flex flex-col gap-1">
                  <Skeleton height={16} width={120} />
                  <Skeleton height={44} />
                </div>
              </div>

              {idx === 1 && (
                <div className="flex justify-end pt-2">
                  <Skeleton height={36} width={260} />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-end items-center gap-3">
        <Skeleton height={44} width={180} />
        <Skeleton height={44} width={120} />
      </div>
    </div>
  );
}
